"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'grill',
    name: 'Grill',
    background_color: '#9f3131',
    background_image: 'https://assets.raydiant.com/images/grill.svg',
    background_image_portrait: 'https://assets.raydiant.com/images/grill-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Kanit-Bold.woff',
    heading_text_color: '#ffffff',
    heading_2_font: 'https://fonts.raydiant.com/Kanit-Medium.woff',
    heading_2_text_color: '#ffad0a',
    body_font: 'https://fonts.raydiant.com/Kanit-Regular.woff',
    body_text_color: '#ffffff',
    border_color: '#ffad0a',
};
//# sourceMappingURL=grill.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/grill.js